import { Component, ViewChild } from '@angular/core';
import { AuthService } from '@core';
import { BillingAddress } from '../../../models/billing-address';
import { PaymentData } from '../../../models/payment-data';
import { PaymentDataFormComponent } from '../../components/payment-data-form/payment-data-form.component';
import { OrderStepBaseComponent } from '../../order-step-base-component';
import { OrderState } from 'app/order/models/order-state.model';

@Component({
    selector: 'app-payment-data',
    templateUrl: './payment-data.component.html',
    styleUrls: ['./payment-data.component.scss'],
    standalone: false,
})
export class PaymentDataComponent extends OrderStepBaseComponent {
    @ViewChild(PaymentDataFormComponent)
    private paymentForm: PaymentDataFormComponent;

    public constructor(public authService: AuthService) {
        super();
    }

    public get payment(): Partial<PaymentData> | undefined {
        return this.state?.payment;
    }

    public get billingAddress(): Partial<BillingAddress> | undefined {
        return this.state?.billingAddress;
    }

    public getData(): Partial<OrderState> {
        return this.paymentForm?.getData();
    }

    public override get isInvalid(): boolean {
        return this.paymentForm?.isInvalid;
    }
}
